import Taro from '@tarojs/api'

// 自定义组件
export const nextTick = Taro.nextTick
